import { ReduxAction } from 'app/redux/types';

// ---

export const CHANGE_SYSTEM_RANK = 'BET_SLIP:CHANGE_SYSTEM_RANK';

export type ChangeSystemRank = ReduxAction<typeof CHANGE_SYSTEM_RANK, {
  value: number;
}>;

export const changeSystemRank = (value: number): ChangeSystemRank => ({
  type: CHANGE_SYSTEM_RANK,
  payload: { value },
});
